export const isImageFile = (filename = '') => {
  return /\.(png|jpe?g|heic|heif|svg|gif|webp|bmp)$/i.test(filename)
}

export const isPdfFile = (filename = '') => {
  return /\.(pdf|ai)$/i.test(filename)
}

export const isTxtFile = (filename = '') => {
  return /\.txt$/i.test(filename)
}

export const isPreviewableFile = (filename = '') => {
  return isImageFile(filename) || isPdfFile(filename) || isTxtFile(filename)
}
